import { useState, useContext, useEffect } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { HttpPostData, JumpPage } from "../../../common/Util";
import { TitleParamContext } from "../../../context/TitleContext";
import { LoginStateConext } from "../../../context/AuthContext";
import { NewProductParam, UserLicenses, PaymentPageType, ResponseParamBase } from "../../../common/Types";
import { OnsiteProgress, OnsiteButton } from "../../../customelements/CustomInput";
import Mail_Pc from "../../../image/Mail_Pc.png";
import Mail_Sp from "../../../image/Mail_Sp.png";
import Delivary_Pc from "../../../image/Delivary_Pc.png";
import Delivary_Sp from "../../../image/Delivary_Sp.png";
import market from "../../../css/market.module.scss";
import faq from "../../../css/faq.module.css";
import base from "../../../css/base.module.css";

export type ResponseParam = ResponseParamBase & {
    list: UserLicenses[],
    deliveryList: UserDeliveryListRow[],
    hasTrial: boolean,
    hasContinue: boolean,
    hasRecipt: boolean,
}

export type UserDeliveryListRow = {
    purchaseDate: string,
    productName: string,
    productCode: string,
    isTrial: boolean,
    quantity: number,
    isDelivery: boolean,
    deliveryType: string,
    deliverysShedule: Date,
    deliveryDateStr: string
}

export const MyPage = () => {

    const ctx = useContext(TitleParamContext);
    const loginState = useContext(LoginStateConext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [dataList, setDataList] = useState<ResponseParam>();

    const displayPccase: boolean = false;


    useEffect(() => {
        (async () => {
            ctx.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "マイページ", secondSubTitle: "" });

            HttpPostData<ResponseParam>("/License/GetUserLicenseData", { Email: loginState.loginInfo.email }, setIsLoading)
                .then((response) => {
                    if (response.data.resultFlg) {
                        setDataList(response.data);
                    }
                })
                .catch(e => { });
        })()
    }, []);

    const navigate = useNavigate();

    const ehPage = function <T>(path: string, param: T, title: string) {
        JumpPage("/MyPage/" + path, param, title, navigate);
    }

    return (
        <>
            <section className={market.marketArea}>
                <div className={faq.faqAreaInner}>
                    <div className={faq.faqBox}>
                        <h3>メニュー</h3>

                        {
                            displayPccase ?
                                <Grid container spacing={1} alignItems="stretch" justifyContent="center" columns={20} >
                                    <Grid item lg={5} xl={4}  >
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("ChangeUserName", {}, ""); }}>利用者名変更</OnsiteButton>
                                    </Grid>
                                    <Grid item lg={5} xl={4}  >
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("ChangePassword", {}, ""); }}>パスワード変更</OnsiteButton>
                                    </Grid>
                                    <Grid item lg={5} xl={4}  >
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("ChangeMailAddress", {}, ""); }}>メールアドレス変更</OnsiteButton>
                                    </Grid>
                                    <Grid item lg={5} xl={4}  >
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("Receipt", {}, ""); }}>領収書発行</OnsiteButton>
                                    </Grid>
                                    <Grid item lg={5} xl={4}  >
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("Inquiry", {}, ""); }}>カスタマーサポート</OnsiteButton>
                                    </Grid>

                                    <Grid item lg={5} xl={8} alignItems="stretch">
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" } as NewProductParam, ""); }}>新規ライセンス購入</OnsiteButton>
                                    </Grid>

                                    <Grid item lg={5} xl={8} alignItems="stretch">
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("ContinueLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.Continue, lisenceKey: "" } as NewProductParam, ""); }}>継続ライセンス購入</OnsiteButton>
                                    </Grid>

                                    <Grid item lg={5} xl={5} alignItems="stretch">
                                        <OnsiteButton className="btn" onClick={(e) => { ehPage("NewLicense", { categoryCode: "02", productCode: "04", paymentPageType: PaymentPageType.Pccase, lisenceKey: "" } as NewProductParam, ""); }}>RPA端末用ケース購入</OnsiteButton>
                                    </Grid>
                                </Grid>
                                :
                                <>
                                    <div className={market.mypageButtonMenu}>
                                        <button className={market.myPageButton2} onClick={(e) => { ehPage("Inquiry", {}, ""); }}>
                                            <span>
                                                <span>カスタマーサポート</span><br />
                                                <span>（お問い合わせ）</span>
                                            </span>
                                        </button>
                                    </div>
                                    <div className={market.mypageButtonMenu}>
                                        <button className={market.myPageButton} onClick={(e) => { ehPage("ChangeUserName", {}, ""); }}>利用者名変更</button>
                                        <button className={market.myPageButton} onClick={(e) => { ehPage("ChangePassword", {}, ""); }}>パスワード変更</button>
                                        <button className={market.myPageButton} onClick={(e) => { ehPage("ChangeMailAddress", {}, ""); }}>メールアドレス変更</button>
                                        <button className={market.myPageButton} disabled={!dataList?.hasRecipt} onClick={(e) => { ehPage("Receipt", {}, ""); }}>領収書発行</button>
                                    </div>
                                    <div className={market.mypageButtonMenu}>
                                        <button className={market.myPageButton2}
                                            onClick={(e) => {
                                                ehPage("NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" } as NewProductParam, "");
                                            }}>
                                            <span>
                                                <span>ClickerAce新規ライセンス購入</span><br />
                                                <span>1ライセンスあたり33,000円／年間</span>
                                            </span>
                                        </button>
                                        <button className={market.myPageButton2}
                                            disabled={!dataList?.hasContinue}
                                            onClick={(e) => {
                                                ehPage("ContinueLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.Continue, lisenceKey: "" } as NewProductParam, "");
                                            }}>
                                            <span>
                                                <span>ClickerAce継続ライセンス購入</span><br />
                                                <span>1ライセンスあたり33,000円／年間</span>
                                            </span>
                                        </button>
                                    </div>
                                </>
                        }
                        <div className={base.messageFont} style={{ marginTop: "30px", marginBottom: "20px" }}>ライセンス購入時の支払いは、Paypalでのみ承っております。</div>
                        <table align="center">
                            <tbody>
                            <tr>
                                <td align="center">
                                    <a href="#" onClick={(e) => { javascript: window.open('https://www.paypal.com/jp/webapps/mpp/logo/about', 'olcwhatispaypal', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=900, height=700'); }}>
                                        <img src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/jp/developer/203x80_b.png" alt="ペイパル｜カード情報も、口座番号も、ペイパルが守ります。｜VISA, Mastercard, JCB, American Express, Union Pay, 銀行" />
                                    </a>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className={base.messageFont} style={{ marginTop: "70px", marginBottom: "10px" }}>
                            [ClickerAceお試しライセンス発行]ボタンより<br />
                            有償サポートの拡張機能を試す場合に必要となる<br />
                            ３か月間利用可能なライセンスコードを発行頂けます。<br />
                            ご利用は、お試し目的に限ります。<br/>
                        </div>
                        <div className={market.mypageButtonMenu}>
                            <button className={market.myPageButton2} disabled={dataList?.hasTrial} onClick={(e) => { ehPage("trial", {}, ""); }}>
                                <span>
                                    <span>ClickerAce</span><br />
                                    <span>お試しライセンス発行</span>
                                </span>
                            </button>
                        </div>
                    </div>
                    
                    <div className={faq.faqBox}>
                        <h3>保有ライセンス</h3>
                        {isLoading ?
                            <div className={base.flexCenterColumn}><OnsiteProgress></OnsiteProgress></div>
                            :
                            <>
                                <section className={base.forPc}>
                                    <table className={base.pcTable} style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>ライセンスコード</th>
                                                <th>有効期間</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList?.list.map((field, index) => {
                                                if (field.isLValidLimit) {
                                                    return (
                                                        <tr key={`license_${index}`}>
                                                            <td>{field.licenseKey}</td>
                                                            <td>
                                                                {field.limitSpanStr}
                                                                {field.isTrial ? <><br /><div style={{ color: "red" }}>※ご利用は、お試し目的に限ります。</div></> : null}
                                                            </td>
                                                        </tr>
                                                    )
                                                } else {
                                                    return (
                                                        <tr key={`license_${index}`} className={base.pcTableDisable}>
                                                            <td>{field.licenseKey}</td>
                                                            <td>
                                                                {field.limitSpanStr}
                                                                {field.isTrial ? <><br /><div style={{ color: "red" }}>※ご利用は、お試し目的に限ります。</div></> : null}
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            })}
                                        </tbody>
                                    </table>
                                    
                                </section>
                                <section className={base.forSp}>
                                    <table className={base.spTable} style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>ライセンスコード</th>
                                                <th>有効期間</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList?.list.map((field, index) => {
                                                if (field.isLValidLimit) {
                                                    return (
                                                        <tr key={`license_${index}`}>
                                                            <td>{field.licenseKey}</td>
                                                            <td>
                                                                {field.limitSpanStartStr}<br />～<br />{field.limitSpanEndStr}
                                                                {field.isTrial ? <><br /><div style={{ color: "red" }}>※ご利用は、お試し目的に限ります。</div></> : null}
                                                            </td>
                                                        </tr>
                                                    )
                                                } else {
                                                    return (
                                                        <tr key={`license_${index}`} className={base.spTableDisable}>
                                                            <td>{field.licenseKey}</td>
                                                            <td>
                                                                {field.limitSpanStartStr}<br />～<br />{field.limitSpanEndStr}
                                                                {field.isTrial ? <><br /><div style={{ color: "red" }}>※ご利用は、お試し目的に限ります。</div></> : null}
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            })}
                                        </tbody>
                                    </table>
                                </section>

                            </>
                        }
                    </div>
                    <div className={faq.faqBox}>
                        <h3>発送履歴</h3>
                        {isLoading ?
                            <div className={base.flexCenterColumn}><OnsiteProgress></OnsiteProgress></div>
                            :
                            <>
                                <section className={base.forPc}>
                                    <table className={base.pcTable} style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>支払日</th>
                                                <th>商品</th>
                                                <th>数量</th>
                                                <th colSpan={2}>発送</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList?.deliveryList.map((field, index) => {
                                                return (
                                                    <tr key={`delivary_${index}`}>
                                                        <td>{field.isTrial ? "" : field.purchaseDate}</td>
                                                        <td>{field.productName}</td>
                                                        <td>{field.quantity}</td>
                                                        <td><img src={field.isDelivery ? Delivary_Pc : Mail_Pc} alt="発送" /></td>
                                                        <td>{field.deliveryDateStr}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </section>
                                <section className={base.forSp}>
                                    <table className={base.spTable} width="100%">
                                        <thead>
                                            <tr>
                                                <th>支払日</th>
                                                <th>商品</th>
                                                <th>数量</th>
                                                <th colSpan={2}>発送</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList?.deliveryList.map((field, index) => {
                                                return (
                                                    <tr key={`delivary_${index}`}>
                                                        <td>{field.isTrial ? "" : field.purchaseDate}</td>
                                                        <td>{field.productName}</td>
                                                        <td>{field.quantity}</td>
                                                        <td><img src={field.isDelivery ? Delivary_Pc : Mail_Pc} alt="発送" /></td>
                                                        <td>{field.deliveryDateStr}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </section>
                            </>
                        }
                    </div>
                </div>
            </section>

        </>
    )
}